import { render, staticRenderFns } from "./newCustomer.vue?vue&type=template&id=0077ca1a&scoped=true"
import script from "./newCustomer.vue?vue&type=script&lang=js"
export * from "./newCustomer.vue?vue&type=script&lang=js"
import style0 from "./newCustomer.vue?vue&type=style&index=0&id=0077ca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077ca1a",
  null
  
)

export default component.exports